export default __webpack_public_path__ + "static/article-fintech-the-changing-face-of-digital-financial-management-c2d9efa2049cc0d606bf94f023ea3580.jpg";